import { render, staticRenderFns } from "./PaymentReceivableExtends.vue?vue&type=template&id=34f4b558"
import script from "./PaymentReceivableExtends.vue?vue&type=script&lang=js"
export * from "./PaymentReceivableExtends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports